<template>
    <div class="container">
        <div class="video-info" v-if="showVideoInfo">
            <blfhsj v-if="pcode === 'blfhsj'"></blfhsj>
            <blfjjp v-if="pcode === 'blfjjp'"></blfjjp>
            <blfkl v-if="pcode === 'blfkl'"></blfkl>
            <blfrjn v-if="pcode === 'blfrjn'"></blfrjn>
            <fkp v-if="pcode === 'fkp'"></fkp>
            <hsjn v-if="pcode === 'hsjn'"></hsjn>
            <pro v-if="pcode === 'pro'"></pro>
            <img class="btn-close" src="img/icon_close@2x.webp" alt="btn-close" @click="closeVideo">
        </div>
        <img class="btn-close" src="img/icon_close@2x.webp" @click="closeMoreInfo" v-if="showIFrameCloseBtn"></img>

        <div class="info">
            <div class="header">
                <!-- <img src="img/logo4.png" alt="LOGO" style="height: 64px;margin: 10px auto;"> -->
                <button class="btn" style="margin-top: 40px;">{{ series }} {{ productName }}</button>
                <p class="alternate-products-tip" v-if="visibleAlternateProducts.length">如果不是想了解的产品，还可以查看:</p>
                <div class="alternate-products-images" v-if="visibleAlternateProducts.length">
                    <div
                        v-for="image in visibleAlternateProducts"
                        :key="image.code"
                        class="alternate-product-item"
                        @click="onAlternateProductClick(image.code)"
                    >
                        <img :src="image.src" :alt="image.alt" />
                    </div>
                </div>
                <!-- <span style="margin: 10px auto; color: darkgray; font-size: .6rem">备注：1 指形成牙本质修复层</span> -->
            </div>
            
            <div class="footer" v-if="!isHide">
                <section>
                    <div class="btn-wrapper" @click="readMore">
                        <img src="img/容器@2x.webp" alt="more-info">
                        <span>产品详情</span>
                    </div>
                    <div class="btn-wrapper" @click="onKgView">
                        <img src="img/otc/bk.png" alt="more-info">
                        <span>产品百科</span>
                    </div>
                </section>
                <section>
                    <!-- <div class="btn-wrapper2" @click="onVoiceMode">
                        <img src="img/otc/qa.png" alt="more-info">
                        <span>智能问答</span>
                    </div> -->
                    <!-- <div class="btn-wrapper" ref="btn">
                        <div class="" id="launch-btn">
                            <div class="placeholder">
                                <div class="">
                                    <img
                                        src="data:image/webp;base64,UklGRvwDAABXRUJQVlA4WAoAAAAwAAAANQAAIQAASUNDUBgCAAAAAAIYAAAAAAQwAABtbnRyUkdCIFhZWiAAAAAAAAAAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAAHRyWFlaAAABZAAAABRnWFlaAAABeAAAABRiWFlaAAABjAAAABRyVFJDAAABoAAAAChnVFJDAAABoAAAAChiVFJDAAABoAAAACh3dHB0AAAByAAAABRjcHJ0AAAB3AAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAFgAAAAcAHMAUgBHAEIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFhZWiAAAAAAAABvogAAOPUAAAOQWFlaIAAAAAAAAGKZAAC3hQAAGNpYWVogAAAAAAAAJKAAAA+EAAC2z3BhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABYWVogAAAAAAAA9tYAAQAAAADTLW1sdWMAAAAAAAAAAQAAAAxlblVTAAAAIAAAABwARwBvAG8AZwBsAGUAIABJAG4AYwAuACAAMgAwADEANkFMUEhxAQAADYCzbdvx5qltTLbtibs2u53z5Rc4WZNvrqfszVzNtm07tb/0vXNwjggHbiMp0q5zDEv9ibCEj4lnYq+Vddv8OdgSDTdWcwu2JHXHOXWWzatOH1OnZYuqplIJ8u5CnplsBvKiUO4PWLM0wGQm1t1FyO6AFLtfKiZkZJ4TqAyMLZF9CyQ1xLSdhZ3VEYWK1FBpSxvT4SWmozqimA6stcSaTL5DtWqCMsXmkF7OQ5yfDPNNxSrSMOm3FUmYJCi6xxyCwmehSi+dOYQFY3VkHn5L5rBLWPTVPfa7QCLjBcysCVviZYAb4s9a/n1oh70ldaSn3+fsLZE4EBGPO7wzR1KU8BnckMEM3R/ghnfM0ZIJLdqVnuZw2yO4gT1z1GtC4xZOmEqUMJVmyDdhElYeoyc653Fjg8xSJ99hGUJa3Cx7mPPmhNiDVW8Ue7I4ITF7DD6c/2JviCHU8BeYR6PAiK5HPy+hoe2pO+sBG7LLS8Z4sG0EAFZQOCBEAAAAkAMAnQEqNgAiAD4xEodCoiEMqgAQAYJaQAAkOyO04CZRBosmwAD+/lXlbkf//9qcSh//8mV8r+///tRNl///aiIAAAA=" />

                                    <span> 疼痛自测</span>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </section>
                <!-- <div class="btn-weixin" ref="btn">
                    <div class="" id="launch-btn">
                        <div class="placeholder">
                            <div class="btn-wrapper">
                                <span>测一测</span>
                                <img
                                    src="data:image/webp;base64,UklGRvwDAABXRUJQVlA4WAoAAAAwAAAANQAAIQAASUNDUBgCAAAAAAIYAAAAAAQwAABtbnRyUkdCIFhZWiAAAAAAAAAAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAAHRyWFlaAAABZAAAABRnWFlaAAABeAAAABRiWFlaAAABjAAAABRyVFJDAAABoAAAAChnVFJDAAABoAAAAChiVFJDAAABoAAAACh3dHB0AAAByAAAABRjcHJ0AAAB3AAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAFgAAAAcAHMAUgBHAEIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFhZWiAAAAAAAABvogAAOPUAAAOQWFlaIAAAAAAAAGKZAAC3hQAAGNpYWVogAAAAAAAAJKAAAA+EAAC2z3BhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABYWVogAAAAAAAA9tYAAQAAAADTLW1sdWMAAAAAAAAAAQAAAAxlblVTAAAAIAAAABwARwBvAG8AZwBsAGUAIABJAG4AYwAuACAAMgAwADEANkFMUEhxAQAADYCzbdvx5qltTLbtibs2u53z5Rc4WZNvrqfszVzNtm07tb/0vXNwjggHbiMp0q5zDEv9ibCEj4lnYq+Vddv8OdgSDTdWcwu2JHXHOXWWzatOH1OnZYuqplIJ8u5CnplsBvKiUO4PWLM0wGQm1t1FyO6AFLtfKiZkZJ4TqAyMLZF9CyQ1xLSdhZ3VEYWK1FBpSxvT4SWmozqimA6stcSaTL5DtWqCMsXmkF7OQ5yfDPNNxSrSMOm3FUmYJCi6xxyCwmehSi+dOYQFY3VkHn5L5rBLWPTVPfa7QCLjBcysCVviZYAb4s9a/n1oh70ldaSn3+fsLZE4EBGPO7wzR1KU8BnckMEM3R/ghnfM0ZIJLdqVnuZw2yO4gT1z1GtC4xZOmEqUMJVmyDdhElYeoyc653Fjg8xSJ99hGUJa3Cx7mPPmhNiDVW8Ue7I4ITF7DD6c/2JviCHU8BeYR6PAiK5HPy+hoe2pO+sBG7LLS8Z4sG0EAFZQOCBEAAAAkAMAnQEqNgAiAD4xEodCoiEMqgAQAYJaQAAkOyO04CZRBosmwAD+/lXlbkf//9qcSh//8mV8r+///tRNl///aiIAAAA=" />
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="tips">
                    <p>声明:产品识别存在误差，3D模型与扫描产品可能存在不一致，具体请以实物为准; 同一产品可能存在新旧包装，详情页中的图片和信息会显示最新包装的信息。</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue';
import { getProductList, getMaterialType, productRecognition } from "@/api/service"
import { getAliyunSigned } from '@/api/service';
import sensodyne from './products/sensodyne/list.vue'
import otc from '@/views/otc/index.vue'
import blfhsj from '@/views/otc/blfhsj.vue'
import blfrjn from '@/views/otc/blfrjn.vue'
import blfjjp from '@/views/otc/blfjjp.vue'
import blfkl from '@/views/otc/blfkl.vue'
import fkp from '@/views/otc/fkp.vue'
import hsjn from '@/views/otc/hsjn.vue'
import pro from '@/views/otc/pro.vue'
import { eventBus } from "@/utils/eventBus"
const showIFrameCloseBtn = ref(false);
const showIFrame = ref(false);
const product = ref("");
const showVideoInfo = ref(false)
const productList = ref(Array[Object])
const videoUrl = ref("")
const productName = ref("")
const series = ref("")
const btn = ref(null);
const videoPlayer = ref(null);
const moreInfoIframe = ref(null);
const code = ref("")
const pcode = ref("")
const isHide = ref(false)
const allAlternateProducts = [
    { src: '/img/otc/pro-2.png', alt: 'Image 2', code: 'blfhsj' },
    { src: '/img/otc/pro-1.png', alt: 'Image 1', code: 'hsjn' },
    { src: '/img/otc/pro-5.png', alt: 'Image 5', code: 'blfrjn' },
    { src: '/img/otc/pro-4.png', alt: 'Image 4', code: 'blfjjp' },
    { src: '/img/otc/pro-3.png', alt: 'Image 3', code: 'blfkl' },
    { src: '/img/otc/pro-6.png', alt: 'Image 6', code: 'fkp' },
]
const currentModelUrl = ref(localStorage.getItem('model_url') || '')
const visibleAlternateProducts = computed(() => {
    const modelUrl = currentModelUrl.value
    if (!modelUrl) return allAlternateProducts
    return allAlternateProducts.filter((item) => item.code !== modelUrl)
})
const updateCurrentModelUrl = () => {
    currentModelUrl.value = localStorage.getItem('model_url') || ''
}
const updateProductInfoByCode = (productCode) => {
    if (!productCode) return
    let id
    for (let v of productList.value) {
        if (v.code === productCode) {
            id = v.id
            series.value = v.series
            productName.value = v.name
            productRecognitionData(id)
            break
        }
    }
    if (!id) return
    getMaterialType(id).then(res => {
        if (res) {
            let list = res.items
            for (let v of list) {
                if (v.product_id == id) {
                    productRecognitionData(v.product_id)
                    break
                }
            }
        }
    })
}
const onAlternateProductClick = (productCode) => {
    showVideoInfo.value = false
    localStorage.setItem('model_url', productCode)
    localStorage.setItem('model_name', productCode)
    currentModelUrl.value = productCode
    updateProductInfoByCode(productCode)
    eventBus.emit('reload_model', productCode)
}
const onVoiceMode = async () => {
    eventBus.emit('voice', 'show')
}
const onKgView = async () => {
    pcode.value = 'pro'
    eventBus.emit('voice', 'hide')
    showVideoInfo.value = true;
}
const readMore = async () => {
    pcode.value = localStorage.getItem('model_name')
    eventBus.emit('voice', 'hide')
    showVideoInfo.value = true;
    return;

    moreInfoIframe.value.contentWindow.location.replace(url)
    // moreInfoIframe.value.onload = function () {
    //     console.log('iframe加载完成');
    // };
    // document.getElementById('moreInfoIframe').addEventListener('load', function () {
    //     console.log('loaded')
    //     const iframe = document.getElementById('moreInfoIframe');
    //     try {
    //         // 确保iframe已加载
    //         if (iframe.contentDocument && iframe.contentDocument.body) {
    //             // 创建并触发点击事件
    //             const clickEvent = new MouseEvent('click', {
    //                 view: window,
    //                 bubbles: true,
    //                 cancelable: true
    //             });
    //             setTimeout(() => {
    //                 iframe.contentDocument.body.dispatchEvent(clickEvent);
    //                 iframe.contentWindow.postMessage({ type: 'playvideo', params: [false] }, '*')
    //                 console.log('成功触发iframe内部body点击事件');
    //             }, 3000);

    //         } else {
    //             console.log('iframe尚未完全加载，请稍后再试');
    //         }
    //     } catch (error) {
    //         console.error('由于安全限制，无法访问iframe内容:', error.message);
    //         alert('由于浏览器安全限制，无法访问此iframe内容。请确保iframe来自同一域名或已正确设置CORS策略。');
    //     }
    // });

    // document.getElementById('moreInfoIframe').addEventListener('DOMContentLoaded', function () {
    //     console.log('DOMContentLoaded')
    //     const iframe = document.getElementById('moreInfoIframe');
    //     try {
    //         // 确保iframe已加载
    //         if (iframe.contentDocument && iframe.contentDocument.body) {
    //             // 创建并触发点击事件
    //             const clickEvent = new MouseEvent('click', {
    //                 view: window,
    //                 bubbles: true,
    //                 cancelable: true
    //             });
    //             iframe.contentDocument.body.dispatchEvent(clickEvent);
    //             iframe.contentWindow.postMessage({ type: 'playvideo', params: [false] }, '*')
    //             console.log('成功触发iframe内部body点击事件');

    //         } else {
    //             console.log('iframe尚未完全加载，请稍后再试');
    //         }
    //     } catch (error) {
    //         console.error('由于安全限制，无法访问iframe内容:', error.message);
    //         alert('由于浏览器安全限制，无法访问此iframe内容。请确保iframe来自同一域名或已正确设置CORS策略。');
    //     }
    // });
}

const closeMoreInfo = () => {
    showIFrame.value = false;
    showIFrameCloseBtn.value = false
}

const closeVideo = () => {
    //eventBus.emit('voice', 'show')
    showVideoInfo.value = false;
};


const getProductInfo = () => {
    updateProductInfoByCode(localStorage.getItem('model_name'))
}

const productRecognitionData = (product_id) => {
    productRecognition({ product_id: product_id }).then(res => {

    })
}

const receiveMessage = (e) => {
    if (!e || !e.data || !e.data.type) return;
    //console.log(e.data, 111);
    switch (e.data.type) {
        case 'showCloseBtn':
            showIFrameCloseBtn.value = e.data.params[0] ?? false;
        //type.value = "show"
        case 'videoLoaded':
            console.log('h5 视频加载好了')
            const iframe = document.getElementById('moreInfoIframe');
            try {
                // 确保iframe已加载
                if (iframe.contentDocument && iframe.contentDocument.body) {
                    // 创建并触发点击事件
                    const clickEvent = new MouseEvent('click', {
                        view: window,
                        bubbles: true,
                        cancelable: true
                    });
                    iframe.contentDocument.body.dispatchEvent(clickEvent);
                    iframe.contentWindow.postMessage({ type: 'playvideo', params: [false] }, '*')
                    console.log('成功触发iframe内部body点击事件');

                } else {
                    console.log('iframe尚未完全加载，请稍后再试');
                }
            } catch (error) {
                console.error('由于安全限制，无法访问iframe内容:', error.message);
                alert('由于浏览器安全限制，无法访问此iframe内容。请确保iframe来自同一域名或已正确设置CORS策略。');
            }
            break;
    }
}

const init = () => {
    getProductList().then(res => {
        if (res) {
            productList.value = res
            getProductInfo()
        }
    })
    //window.addEventListener('message', receiveMessage, false);
    eventBus.on('showCloseBtn', showCloseBtn)
    eventBus.on('hideCloseBtn', hideCloseBtn)
}

const showCloseBtn = () => {
    showIFrameCloseBtn.value = true;
}

const hideCloseBtn = () => {
    showIFrameCloseBtn.value = false;
}

const getWxConfig = () => {
    //获取阿里云签名
    getAliyunSigned().then(response => {
        if (response) {
            // localStorage.setItem('haleon_token', res.access_token)
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
                appId: response.appId, // 必填，公众号的唯一标识
                nonceStr: response.nonceStr, // 必填，生成签名的随机串
                timestamp: response.timestamp, // 必填，生成签名的时间戳
                signature: response.signature,// 必填，签名
                jsApiList: ['chooseImage'], // 必填，需要使用的JS接口列表
                openTagList: ['wx-open-launch-weapp'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
            });

            wx.ready(function () {
                // This will be called when the WeChat JS-SDK is ready
                console.log('ok')
                insertBtn();
            });
        }
    })
}


onMounted(() => {
    updateCurrentModelUrl()
    init();
    //getWxConfig();
    eventBus.on('model_found', updateCurrentModelUrl)
    eventBus.on('model_hide', (value) => {
        console.log(value)
        isHide.value = value
    })
});

const insertBtn = () => {
    if (btn.value) {
        btn.value.innerHTML = `<wx-open-launch-weapp
        id="launch-btn"
        username="gh_d4b0f39f7133"
        appid="wxf8cfb55d81341236"
        path="pages/index/index">
        <script type="text/wxtag-template">
          <style>
            .placeholder {
                display: flex;
                justify-content: center;
                align-items: center;
                background: linear-gradient(90deg, #ff5f5f 0%, #be515b 100%);
                border-radius: 32px;
                padding: 4px;
                height: 36px;
                color: #fff;
            }

            .btn-wrapper {
                pointer-events: auto;
                display: flex;
                justify-content: space-around;
                align-items: center;
                color: white;
                padding: .6rem 0;
                gap: 0 .6rem;
                height: 2rem;
                color: #fff;
            }

            img {
                width: 1.4rem;
            }
            .color_w{
                color:white
            }
          </style>

          <div class="placeholder">
            <div class="">
              <span class="color_w">测一测</span>
              <img src="data:image/webp;base64,UklGRvwDAABXRUJQVlA4WAoAAAAwAAAANQAAIQAASUNDUBgCAAAAAAIYAAAAAAQwAABtbnRyUkdCIFhZWiAAAAAAAAAAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAAHRyWFlaAAABZAAAABRnWFlaAAABeAAAABRiWFlaAAABjAAAABRyVFJDAAABoAAAAChnVFJDAAABoAAAAChiVFJDAAABoAAAACh3dHB0AAAByAAAABRjcHJ0AAAB3AAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAFgAAAAcAHMAUgBHAEIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFhZWiAAAAAAAABvogAAOPUAAAOQWFlaIAAAAAAAAGKZAAC3hQAAGNpYWVogAAAAAAAAJKAAAA+EAAC2z3BhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABYWVogAAAAAAAA9tYAAQAAAADTLW1sdWMAAAAAAAAAAQAAAAxlblVTAAAAIAAAABwARwBvAG8AZwBsAGUAIABJAG4AYwAuACAAMgAwADEANkFMUEhxAQAADYCzbdvx5qltTLbtibs2u53z5Rc4WZNvrqfszVzNtm07tb/0vXNwjggHbiMp0q5zDEv9ibCEj4lnYq+Vddv8OdgSDTdWcwu2JHXHOXWWzatOH1OnZYuqplIJ8u5CnplsBvKiUO4PWLM0wGQm1t1FyO6AFLtfKiZkZJ4TqAyMLZF9CyQ1xLSdhZ3VEYWK1FBpSxvT4SWmozqimA6stcSaTL5DtWqCMsXmkF7OQ5yfDPNNxSrSMOm3FUmYJCi6xxyCwmehSi+dOYQFY3VkHn5L5rBLWPTVPfa7QCLjBcysCVviZYAb4s9a/n1oh70ldaSn3+fsLZE4EBGPO7wzR1KU8BnckMEM3R/ghnfM0ZIJLdqVnuZw2yO4gT1z1GtC4xZOmEqUMJVmyDdhElYeoyc653Fjg8xSJ99hGUJa3Cx7mPPmhNiDVW8Ue7I4ITF7DD6c/2JviCHU8BeYR6PAiK5HPy+hoe2pO+sBG7LLS8Z4sG0EAFZQOCBEAAAAkAMAnQEqNgAiAD4xEodCoiEMqgAQAYJaQAAkOyO04CZRBosmwAD+/lXlbkf//9qcSh//8mV8r+///tRNl///aiIAAAA="/>
            </div>
          </div>
        <\/script>
      </wx-open-launch-weapp>`;
    }
};

</script>

<style lang="scss" scoped>
.container {
    width: 100vw;
    height: 100vh;
    z-index: 500;
    user-select: none;
    pointer-events: none;

    .btn {
        padding: 0 2rem;
        border-radius: 26px;
        border-width: 0;
        color: white;
        background: linear-gradient(270deg, #ff5f5f 0%, #be515b 100%);
        //background-color: #AA3843;
        //linear-gradient(90deg, #ff5f5f 0%, #be515b 100%);
        text-shadow: 0 4px 10px rgba(0, 0, 0, 0.6);
        font-size: 1.5rem;
        letter-spacing: 1px;
        height: 40px;
        line-height: 40px;
        pointer-events: auto;
    }

    .half-font-size {
        font-size: .75rem;
        color: #efefef;
    }

    .info {
        width: 100%;
        height: 100%;
        max-width: 450px;
        min-width: 400px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background: transparent;
        user-select: none;
        pointer-events: none;
        z-index: 400;

        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;


        .header {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .repair-list {
                margin-top: 1rem;
            }

            .alternate-products-tip {
                margin-top: 16px;
                font-size: 0.85rem;
                color: #ededed;
                text-align: center;
                pointer-events: auto;
            }

            .alternate-products-images {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 10px;
                margin-top: 12px;
                padding: 0 16px;
                width: 100%;
                max-width: 420px;
                pointer-events: auto;
            }

            .alternate-product-item {
                flex: 1;
                min-width: 52px;
                aspect-ratio: 1;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                    border-radius: 8px;
                }
            }
        }

        .content {
            flex: 1;
            width: 100%;
            display: flex;
            position: relative;
            flex-direction: column;
            justify-content: flex-end;
            align-items: center;
            //outline: 1px solid white;

            .center-tip {
                min-height: 40px;
                width: 80%;
                //outline: 1px solid deepskyblue;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                user-select: none;
                pointer-events: none;
                gap: 1rem 0;

                img {
                    padding-top: 40%;
                    width: 100%;
                    height: 100%;
                }

                span {
                    text-shadow: 0 2px 3px rgba(0, 0, 0, 0.3);
                    font-weight: 500;
                    font-size: .8rem;
                    color: #EDEDED;
                }
            }

            .bottom-tip {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 80%;
                //outline: 1px solid black;
                position: absolute;
                bottom: 10%;
                left: 50%;
                transform: translateX(-50%);

                span {
                    font-size: .8rem;
                }

                span:nth-of-type(1) {
                    visibility: hidden;
                }

                span:nth-of-type(2) {
                    pointer-events: auto;
                }

                img {
                    vertical-align: -4px;
                }

            }
        }

        .footer {
            overflow: hidden;
            position: fixed;
            bottom: 60px;
            left: 0;
            height: 172px;
            width: 100vw;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;

            section {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 80%;
                margin-bottom: 10px;

                .btn-wrapper {
                    // background: linear-gradient(90deg, #0324A9 0%, #03D3EA 100%);
                    background: linear-gradient(90deg, #ff5f5f 0%, #be515b 100%);
                    //background-color: #AA3843;
                    border-radius: 32px;
                    width: 44%;
                    pointer-events: auto;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: white;
                    padding: 4px;
                    gap: 0 10px;
                    height: 36px;


                    img {
                        width: 22px;
                    }

                }

                .btn-wrapper2 {
                    // background: linear-gradient(90deg, #0324A9 0%, #03D3EA 100%);
                    background: linear-gradient(90deg, #ff5f5f 0%, #be515b 100%);
                    //background-color: #AA3843;
                    border-radius: 32px;
                    width: 100%;
                    pointer-events: auto;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: white;
                    padding: 4px;
                    gap: 0 10px;
                    height: 36px;


                    img {
                        width: 22px;
                    }

                }
            }

            .tips {
                position: fixed;
                bottom: 40px;
                width: calc(100vw - 80px);
                padding: 0px 40px;
                font-size: 9px;
                color: #939393;
                pointer-events: auto;
                text-align: center;
            }
        }
    }

    .more-info {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: #000000;
        z-index: 500;
    }

}

@media screen and (orientation: landscape) {
    .container {
        width: 100vh;
        height: 100vw;
        transform-origin: left top;
        transform: rotate(-90deg) translateX(-100%);
    }
}

.btn-close {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 99999999;
    width: 14vw;
    pointer-events: auto;
}

.iframe-box {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 997;
    background-color: #000000;
    border: 0;
    pointer-events: auto;
    overflow-y: scroll;
}

.video-info {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: #000000;
    z-index: 9999999;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: auto;

    .btn-close {
        position: fixed;
        top: 0;
        right: 0;
        z-index: 1;
        width: 3rem;
    }
}

.video {
    width: 100vw;
    object-fit: contain;
}

.btn-weixin {
    pointer-events: auto;
    width: 80%;
    height: 44px;
    display: block;
    margin-top: 10px;
}



/***ddddd */
.placeholder {
    display: flex;
    justify-content: center;
    align-items: center;
    // background: linear-gradient(90deg, #0324A9 0%, #03D3EA 100%);
    background: linear-gradient(90deg, #ff5f5f 0%, #be515b 100%);
    //background-color: #AA3843;
    border-radius: 32px;
    padding: 4px;
    height: 36px;
}

.btn-wrapper {
    pointer-events: auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: white;
    padding: .6rem 0;
    gap: 0 .6rem;
    height: 2rem;

    img {
        width: 1.4rem;
    }
}
</style>